import { render, staticRenderFns } from "./AyudaParte2Muelle.vue?vue&type=template&id=61176fc4&scoped=true"
import script from "./AyudaParte2Muelle.vue?vue&type=script&lang=js"
export * from "./AyudaParte2Muelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61176fc4",
  null
  
)

export default component.exports